import React from 'react'

const Manual_canjear_beneficios_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Canjear beneficios desde el e-commerce
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende cómo los usuarios pueden canjear beneficios directamente desde el sitio e-commerce de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Canjear_beneficios_desde_el_e-commerce__jU-xF-mzRPKe5nOxDrcnGw?as=scrollable"
          className="scribe-iframe-general-139"
          width="100%"
          height="3700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_canjear_beneficios_ecommerce
